// Shared utilities for quotation status display (colors and labels)
// Backend enum (see Quotation.js):
// ['draft', 'finalized', 'sent', 'seen', 'accepted', 'rejected', 'expired', 'revoked', 'converted', 'order', 'ordered']

// Tailwind class mapping for each status
export const QUOTATION_STATUS_COLORS = {
  draft: 'bg-gray-100 text-gray-800',
  finalized: 'bg-blue-100 text-blue-800',
  sent: 'bg-yellow-100 text-yellow-800',
  seen: 'bg-purple-100 text-purple-800',
  accepted: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
  expired: 'bg-red-100 text-red-800',
  revoked: 'bg-orange-100 text-orange-800',
  converted: 'bg-indigo-100 text-indigo-800',
  order: 'bg-indigo-100 text-indigo-800',
  ordered: 'bg-indigo-100 text-indigo-800'
};

const DEFAULT_STATUS_CLASSES = 'bg-gray-100 text-gray-800';

// Returns Tailwind classes for a given quotation status (case-insensitive)
export const getQuotationStatusClasses = (status) => {
  if (!status) return DEFAULT_STATUS_CLASSES;
  const key = status.toString().toLowerCase();
  return QUOTATION_STATUS_COLORS[key] || DEFAULT_STATUS_CLASSES;
};

// Human-friendly label for a given status (case-insensitive)
export const formatQuotationStatus = (status) => {
  if (!status) return 'Draft';
  const normalized = status.toString().toLowerCase();

  // Custom labels for some statuses if needed
  switch (normalized) {
    case 'order':
      return 'Ready to Order';
    case 'ordered':
      return 'Placed Order';
    default:
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  }
};


